module.exports = __webpack_public_path__ + "static/img/logo@2x.18ef4e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/logo/logo@2x.png
// module id = n7rN
// module chunks = 26